import {
  Box,
  Button,
  Container,
  Icon,
  Icons,
  Stack,
  Typography,
} from '@nextiva/next-ui-components';
import React from 'react';

export function SubmitConfirmation({
  onDoneClick,
}: {
  onDoneClick: () => void;
}) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="80vh"
    >
      <Container>
        <Stack spacing={4} sx={{ textAlign: 'center' }}>
          <Box mx="auto">
            <Icon icon={Icons.checkCircleSolid} size={64} color="success" />
          </Box>
          <Typography color="#008763" variant="h4">
            Business text messaging registration submitted
          </Typography>
          <Typography variant="subtitle1">
            Your information has been submitted for external messaging
            registration. It takes about 10-30 business days to process your
            request and complete the registration. You can continue sending
            internal messages to your teammates as normal. We will reach out if
            additional information is requested for your external messaging
            registration.
          </Typography>
          <div>
            <Button
              color="primary"
              onClick={onDoneClick}
              size="medium"
              variant="contained"
              data-testid="submit-confirmation-submit-button"
              fullWidth={false}
            >
              Done
            </Button>
          </div>
        </Stack>
      </Container>
    </Box>
  );
}
